import React, { useState } from "react";
import LayoutCenter from "../UserInterface/LayoutCenter";
import Button from "../UserInterface/Button";
import Modal from "../UserInterface/Modal";
import LeadsForm from "../../components/LeadsForm";
import AppStore from "../../../public/static/images/svg/AppStore.svg";
import PlayStore from "../../../public/static/images/svg/PlayStore.svg";

type BlogCTAProps = {
  ajukanBtn?: string;
  downloadBtn?: string;
  slug: string;
};

const BlogCTA = ({ ajukanBtn, downloadBtn, slug }: BlogCTAProps) => {
  const [show, setShow] = useState(false);

  const handleModal = () => {
    setShow(true);
  };
  const close = () => {
    setShow(false);
  };
  return (
    <LayoutCenter column>
      {ajukanBtn && (
        <div className="button-container">
          <p className="ajukan-title">Klik tombol di bawah ini untuk…</p>
          <Button text={ajukanBtn} onClick={handleModal}></Button>
        </div>
      )}
      {downloadBtn && (
        <div className="button-container">
          <p>Download My Home Credit App</p>
          <a href={downloadBtn}>
            <img src={PlayStore}></img>
            <img src={AppStore}></img>
          </a>
        </div>
      )}
      {show && (
        <Modal close={close}>
          <LeadsForm
            description="Halo! Kami dengan senang hati akan membantu Anda mengajukan aplikasi kredit barang impian Anda! Isi data berikut dan kami akan segera menghubungi Anda."
            title="Formulir Pengajuan"
            valueDump={{ commodity: slug }}
          ></LeadsForm>
        </Modal>
      )}
      <style jsx>{`
        .button-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          border-bottom: solid 2px #c8c8c8;
          width: 100%;
          margin-bottom: 32px;
          padding-bottom: 32px;
        }
        p {
          margin: 0px 0px 24px 0px;
          font-size: 24px;
          font-weight: bold;
        }
        a {
          max-width: 423px;
          width: 100%;
          display: flex;
          justify-content: space-between;
        }
        .ajukan-title {
          font-size: 17px;
          margin-bottom: 16px;
        }
        @media only screen and (max-width: 600px) {
          a {
            max-width: 235px;
          }
          p {
            font-size: 17px;
          }
          img {
            width: 105px;
          }
        }
      `}</style>
    </LayoutCenter>
  );
};

export default BlogCTA;
